var map = {
	"./kaiping1.png": 239,
	"./kaiping2.png": 240
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack ^\.\/kaiping.*\.png$
// module id = 256
// module chunks = 1